import { DNAButton, DNAText, DNABox, Icon, useOrientationChange, util } from '@alucio/lux-ui';
import { StyleSheet } from 'react-native';
import React from 'react';
const styles = StyleSheet.create({
    icon: {
        width: 28,
        height: 28,
        color: 'rgba(255, 255, 255, 0.4)',
    },
    menuItemText: {
        color: 'rgba(255, 255, 255, 0.4)',
        textAlign: 'center',
        textAlignVertical: 'center',
    },
});
export function DNAMenuItem(props) {
    const { labels, icons, enabled, onPress } = props;
    const icon = enabled ? icons[0] : icons[1];
    const label = enabled ? labels[0] : labels[1];
    const orientation = useOrientationChange();
    return (React.createElement(DNAButton, { appearance: "ghost", size: "tiny", onPress: onPress },
        React.createElement(DNABox, { alignX: "center", alignY: "center", appearance: "col", style: orientation === 'PORTRAIT' ? { maxWidth: 40 } : null },
            React.createElement(Icon, { name: icon, style: util.mergeStyles(undefined, styles.icon) }),
            React.createElement(DNAText, { style: styles.menuItemText }, label),
            props.chip)));
}
//# sourceMappingURL=DNAMenuItem.js.map